// extracted by mini-css-extract-plugin
module.exports = {"editableImg":"style_editableImg__1A2SH","editableImgRelative":"style_editableImgRelative__3PPhh","buttons":"style_buttons__1nuvS","image":"style_image__22und"};